import { Component } from '@angular/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { BlankValueComponent } from './blank-value';

@Component({
  template: `
    @if (!value) {
      <glxy-blank-value />
    } @else {
      @if (value.length > 0) {
        <div class="tags">
          <glxy-badge [glxyTooltip]="value.join(', ')">{{ value[0] }}</glxy-badge>
          @if (value.length === 2) {
            <glxy-badge [glxyTooltip]="value.join(', ')">{{ value[1] }}</glxy-badge>
          }
          @if (value.length > 2) {
            <glxy-badge [glxyTooltip]="value.join(', ')">+{{ value.length - 1 }}</glxy-badge>
          }
        </div>
      }
    }
  `,
  styleUrls: ['./tags.scss'],
  imports: [BlankValueComponent, GalaxyBadgeModule, GalaxyTooltipModule],
})
export class TagsRendererComponent {
  value: string[] = [];
}
